import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const SignKeyKey = 'loginSignKey'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 登录成功后由后端返回的正式签名密钥
export function getSignKey() {
  return localStorage.getItem(SignKeyKey) || ''
}

export function setSignKey(signKey) {
  if (signKey) {
    localStorage.setItem(SignKeyKey, signKey)
  }
}

export function removeSignKey() {
  localStorage.removeItem(SignKeyKey)
}
